import { type ComponentType, type ReactNode, useEffect, useState } from 'react'

interface MarkdownRendererProps {
  content: string
  components?: Record<string, unknown>
  fallback?: ReactNode
}

export default function MarkdownRenderer({
  content,
  components,
  fallback,
}: MarkdownRendererProps) {
  const [MarkdownComponent, setMarkdownComponent] = useState<ComponentType<any> | null>(null)
  const [remarkGfmPlugin, setRemarkGfmPlugin] = useState<any>(null)

  useEffect(() => {
    let active = true

    void Promise.all([import('react-markdown'), import('remark-gfm')]).then(
      ([markdownModule, remarkGfmModule]) => {
        if (!active) return
        setMarkdownComponent(() => markdownModule.default)
        setRemarkGfmPlugin(() => remarkGfmModule.default)
      },
    )

    return () => {
      active = false
    }
  }, [])

  if (!MarkdownComponent || !remarkGfmPlugin) {
    if (fallback) return <>{fallback}</>
    return <div>{content}</div>
  }

  return (
    <MarkdownComponent
      remarkPlugins={[remarkGfmPlugin]}
      components={components}
    >
      {content}
    </MarkdownComponent>
  )
}
